var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('AdminPuzzleList',{staticClass:"u-margin-bottom"}),_c('AdminTextList',{staticClass:"u-margin-bottom"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }